import React from 'react';

import { Logo } from '@/components/ui/logo';
import { useSidebar } from './SidebarContext';
import { SidebarNavigation } from './SidebarNavigation';
import { SidebarToggle } from './SidebarToggle';

export const Sidebar: React.FC = () => {
  const { isExpanded, setExpanded } = useSidebar();

  const handleOverlayClick = () => {
    if (window.innerWidth < 1024) {
      setExpanded(false);
    }
  };

  return (
    <>
      {isExpanded && (
        <div
          className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden"
          onClick={handleOverlayClick}
          aria-hidden="true"
        />
      )}

      <aside
        className={`
          fixed lg:static top-0 left-0 z-30 h-full bg-sidebar border-r border-sidebar-border
          transition-all duration-300 ease-in-out
          ${
            isExpanded
              ? 'w-64 translate-x-0'
              : 'w-24 -translate-x-full lg:translate-x-0'
          }
          lg:flex lg:flex-col
        `}
      >
        <div className="flex items-center h-24 px-4 ">
          <Logo size="xl" />
        </div>

        <div className="flex-1 overflow-y-auto">
          <SidebarNavigation />
        </div>

        <div className="absolute top-4 -right-4.5 z-40">
          <SidebarToggle />
        </div>
      </aside>
    </>
  );
};
